module.exports = __webpack_public_path__ + "img/qr.a8dde951.jpg";